import React from 'react';
import {
    CaretDownOutlined,
    useBreakpoint,
    Popover,
    Button,
} from '@landr/maestro';
import { KeyControl } from 'components/Creator/KeyControl';
import { KeyQuality } from 'types/generated/graphql';
import { KeyControlPopoverProps } from './KeyControlPopover.types';

export const KeyControlPopover = ({
    keyQuality,
    normalizedRootValue,
    isDisabled = false,
}: KeyControlPopoverProps): JSX.Element => {
    const isMobile = useBreakpoint('md');

    const abbreviatedKeyQuality = keyQuality === KeyQuality.Major ? '' : 'm';

    const fullRootAndQuality = `${normalizedRootValue} ${keyQuality}`;
    const abbrRootAndQuality = `${normalizedRootValue}${abbreviatedKeyQuality}`;
    const responsiveRootAndQuality = isMobile
        ? abbrRootAndQuality
        : fullRootAndQuality;

    return (
        <Popover placement="top-end">
            {({ close }): JSX.Element => (
                <>
                    <Popover.Trigger>
                        <Button
                            variant="ghost"
                            isRounded
                            size="sm"
                            iconRight={() =>
                                isMobile ? undefined : (
                                    <CaretDownOutlined
                                        color="icon.low"
                                        size="sm"
                                    />
                                )
                            }
                            isDisabled={isDisabled}
                        >
                            {responsiveRootAndQuality}
                        </Button>
                    </Popover.Trigger>
                    <Popover.Content
                        py="none"
                        px="none"
                        color={undefined}
                        backgroundColor={undefined}
                    >
                        <KeyControl onClick={close} />
                    </Popover.Content>
                </>
            )}
        </Popover>
    );
};
